import { STORAGE_KEY, STORYGRAPH_PILL_STYLE, type TransferData } from '../../constants'
import { maybeDownloadCover } from '../../utils/download'
import { getUserOptions } from '../settings'
import { parseKoboPage } from './parser'

const KOBO_BUTTON_CLASS = 'kobo-port-to-sg-btn'
const KOBO_BUTTON_STYLE = `${STORYGRAPH_PILL_STYLE} margin:6px 0 0;`

function openStoryGraphSearch (data: TransferData): void {
  const query = data.isbn || data.title
  const url = `https://app.thestorygraph.com/browse?search_term=${encodeURIComponent(query)}`
  if (typeof GM_openInTab === 'function') {
    GM_openInTab(url, { active: true })
  } else {
    window.open(url, '_blank')
  }
}

function isKoboBookPage (): boolean {
  return /\/(ebook|audiobook)\//.test(window.location.pathname)
}

function getKoboPrimaryMetadataWidget (): HTMLElement | null {
  return document.querySelector<HTMLElement>('[data-kobo-widget="ItemDetailPrimaryMetadataWidget"], .ItemDetailPrimaryMetadataWidget, .item-primary-metadata.book-primary-metadata')
}

function uniqueElements (elements: HTMLElement[]): HTMLElement[] {
  return elements.filter((element, index, allElements) => allElements.indexOf(element) === index)
}

function hasUsefulTitleText (element: HTMLElement): boolean {
  return (element.textContent || '').trim().length > 3
}

function getKoboTitleTargets (): HTMLElement[] {
  const primaryMetadata = getKoboPrimaryMetadataWidget()
  const scopedTitles = primaryMetadata
    ? Array.from(primaryMetadata.querySelectorAll<HTMLElement>('.title-widget h1, h1.title.product-field, h1.title, h1[data-track-info]'))
    : []
  const globalTitles = Array.from(document.querySelectorAll<HTMLElement>('[data-testid="book-title"], .title-widget h1, .product-title h1, main h1.title, h1.title.product-field, h1[data-track-info]'))

  return uniqueElements([...scopedTitles, ...globalTitles]).filter(hasUsefulTitleText)
}

function createPortButton (): HTMLAnchorElement {
  const btn = document.createElement('a')
  btn.href = '#'
  btn.className = KOBO_BUTTON_CLASS
  btn.textContent = 'Port to StoryGraph'
  btn.style.cssText = KOBO_BUTTON_STYLE

  btn.addEventListener('click', (event) => {
    event.preventDefault()
    const data = parseKoboPage()
    const options = getUserOptions()

    if (options.downloadKoboCover) {
      maybeDownloadCover(data.title, data.coverUrl)
    }

    GM_setValue(STORAGE_KEY, JSON.stringify(data))
    openStoryGraphSearch(data)
  })

  return btn
}

function injectButtonAfterTitle (title: HTMLElement): void {
  const existingNextButton = title.nextElementSibling
  if (existingNextButton?.classList.contains(KOBO_BUTTON_CLASS)) return

  const existingSiblingButton = title.parentElement?.querySelector<HTMLAnchorElement>(`:scope > .${KOBO_BUTTON_CLASS}`)
  if (existingSiblingButton) {
    title.insertAdjacentElement('afterend', existingSiblingButton)
    return
  }

  title.insertAdjacentElement('afterend', createPortButton())
}

export function injectKoboPortButton (): void {
  if (!isKoboBookPage()) return

  document.getElementById('kobo-port-to-sg-btn')?.remove()

  const titles = getKoboTitleTargets()
  if (titles.length === 0) return

  titles.forEach(injectButtonAfterTitle)
}
